import { Component } from '@angular/core';
import { BlockBaseComponent } from "../block-base/block-base.component";
import { StoreSelectorsService } from "../../../../services/store-selectors.service";
import { MatDialog } from "@angular/material/dialog";
import { TranslocoService } from "@ngneat/transloco";


@Component({
    selector: 'app-block-webcam',
    templateUrl: './block-webcam.component.html',
    styleUrls: ['./block-webcam.component.scss']
})
export class BlockWebcamComponent extends BlockBaseComponent {
    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override submit(formValues) {
        return super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.inputNumber', {}, this.translocoService.getActiveLang()),
                inputType: "number",
                name: "index",
                storePath: 'Data[0].Camera[0].$.index'
            },
        ];
        
    }
}
